module.exports = __webpack_public_path__ + "img/CM-SS-25-Mitsubishi-Modern.ac4b766b.jpg";